// extracted by mini-css-extract-plugin
module.exports = {"string":"string_string__5Pi59"};